import * as React from "react"

export const AccountCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.082 14.223a8.6 8.6 0 0 1 2.346-1.142A8.8 8.8 0 0 1 10 12.709q1.35 0 2.572.373 1.221.374 2.346 1.142a5.9 5.9 0 0 0 1.18-1.936A6.5 6.5 0 0 0 16.5 10q0-2.702-1.9-4.601-1.901-1.9-4.605-1.9-2.703 0-4.6 1.9-1.895 1.9-1.895 4.6 0 1.206.402 2.288a5.9 5.9 0 0 0 1.18 1.935ZM10 11.29a2.7 2.7 0 0 1-1.977-.814A2.7 2.7 0 0 1 7.208 8.5q0-1.163.815-1.977A2.7 2.7 0 0 1 10 5.708q1.162 0 1.977.815.815.814.815 1.977 0 1.161-.815 1.976a2.7 2.7 0 0 1-1.977.815Zm.006 6.292a7.5 7.5 0 0 1-2.954-.589 7.6 7.6 0 0 1-4.046-4.045 7.5 7.5 0 0 1-.59-2.959q0-1.577.59-2.949a7.6 7.6 0 0 1 4.046-4.036 7.5 7.5 0 0 1 2.958-.588q1.576 0 2.948.588a7.63 7.63 0 0 1 4.036 4.041q.59 1.377.59 2.948a7.5 7.5 0 0 1-.59 2.954 7.6 7.6 0 0 1-4.04 4.046q-1.376.59-2.948.59ZM10 16.5a6.4 6.4 0 0 0 2.175-.384 6.6 6.6 0 0 0 1.943-1.098 7.6 7.6 0 0 0-1.94-.907 7.4 7.4 0 0 0-2.178-.32 7.9 7.9 0 0 0-2.193.306 6.3 6.3 0 0 0-1.926.92 6.6 6.6 0 0 0 1.944 1.1A6.4 6.4 0 0 0 10 16.5m0-6.292q.705 0 1.207-.502.501-.501.501-1.206c0-.705-.167-.873-.501-1.207A1.65 1.65 0 0 0 10 6.791q-.705 0-1.207.502A1.65 1.65 0 0 0 8.292 8.5q0 .705.501 1.207.502.501 1.207.501"
    ></path>
  </svg>
)
